var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGptChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 244,
    viewBox: "0 0 290 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdddii_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_36794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.7021,
    y: 23.3275,
    width: 220.595,
    height: 175.345,
    rx: 11.3126,
    fill: "url(#paint0_linear_664_36794)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.7021,
    y: 23.3275,
    width: 220.595,
    height: 175.345,
    rx: 11.3126,
    fill: "url(#paint1_linear_664_36794)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.41407,
    height: 175.345,
    transform: "translate(144.293 23.3275)",
    fill: "#0E0948",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.293,
    y: 33.2262,
    width: 1.41407,
    height: 72.1177,
    rx: 0.707036,
    fill: "url(#paint2_linear_664_36794)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.293,
    y: 142.11,
    width: 1.41407,
    height: 45.2503,
    rx: 0.707036,
    fill: "url(#paint3_linear_664_36794)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_664_36794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.254 98.2735C121.035 98.2735 121.668 97.6404 121.668 96.8594C121.668 96.0784 121.035 95.4453 120.254 95.4453C119.473 95.4453 118.84 96.0784 118.84 96.8594C118.84 97.6404 119.473 98.2735 120.254 98.2735Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.042 159.079C99.823 159.079 100.456 158.446 100.456 157.665C100.456 156.884 99.823 156.25 99.042 156.25C98.261 156.25 97.6279 156.884 97.6279 157.665C97.6279 158.446 98.261 159.079 99.042 159.079Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.668 79.8908C122.449 79.8908 123.082 79.2577 123.082 78.4767C123.082 77.6957 122.449 77.0626 121.668 77.0626C120.887 77.0626 120.254 77.6957 120.254 78.4767C120.254 79.2577 120.887 79.8908 121.668 79.8908Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.699 146.352C105.48 146.352 106.113 145.719 106.113 144.938C106.113 144.157 105.48 143.524 104.699 143.524C103.918 143.524 103.285 144.157 103.285 144.938C103.285 145.719 103.918 146.352 104.699 146.352Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.042 181.704C99.823 181.704 100.456 181.071 100.456 180.29C100.456 179.509 99.823 178.876 99.042 178.876C98.261 178.876 97.6279 179.509 97.6279 180.29C97.6279 181.071 98.261 181.704 99.042 181.704Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.273 167.563C132.664 167.563 132.98 167.246 132.98 166.856C132.98 166.465 132.664 166.149 132.273 166.149C131.883 166.149 131.566 166.465 131.566 166.856C131.566 167.246 131.883 167.563 132.273 167.563Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.085 122.313C53.4755 122.313 53.792 121.997 53.792 121.606C53.792 121.216 53.4755 120.899 53.085 120.899C52.6945 120.899 52.3779 121.216 52.3779 121.606C52.3779 121.997 52.6945 122.313 53.085 122.313Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3272 88.3751C57.7176 88.3751 58.0342 88.0586 58.0342 87.6681C58.0342 87.2776 57.7176 86.9611 57.3272 86.9611C56.9367 86.9611 56.6201 87.2776 56.6201 87.6681C56.6201 88.0586 56.9367 88.3751 57.3272 88.3751Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4287 167.563C47.8192 167.563 48.1358 167.246 48.1358 166.856C48.1358 166.465 47.8192 166.149 47.4287 166.149C47.0382 166.149 46.7217 166.465 46.7217 166.856C46.7217 167.246 47.0382 167.563 47.4287 167.563Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8115 55.8514C66.202 55.8514 66.5186 55.5348 66.5186 55.1444C66.5186 54.7539 66.202 54.4373 65.8115 54.4373C65.421 54.4373 65.1045 54.7539 65.1045 55.1444C65.1045 55.5348 65.421 55.8514 65.8115 55.8514Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3975 96.8594C64.788 96.8594 65.1045 96.5428 65.1045 96.1523C65.1045 95.7619 64.788 95.4453 64.3975 95.4453C64.007 95.4453 63.6904 95.7619 63.6904 96.1523C63.6904 96.5428 64.007 96.8594 64.3975 96.8594Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2256 150.594C67.6161 150.594 67.9326 150.278 67.9326 149.887C67.9326 149.497 67.6161 149.18 67.2256 149.18C66.8351 149.18 66.5186 149.497 66.5186 149.887C66.5186 150.278 66.8351 150.594 67.2256 150.594Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.819 139.282C107.21 139.282 107.526 138.965 107.526 138.575C107.526 138.184 107.21 137.868 106.819 137.868C106.429 137.868 106.112 138.184 106.112 138.575C106.112 138.965 106.429 139.282 106.819 139.282Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.477 67.164C112.867 67.164 113.184 66.8475 113.184 66.457C113.184 66.0665 112.867 65.7499 112.477 65.7499C112.086 65.7499 111.77 66.0665 111.77 66.457C111.77 66.8475 112.086 67.164 112.477 67.164Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.648 79.8905C110.039 79.8905 110.355 79.5739 110.355 79.1834C110.355 78.7929 110.039 78.4764 109.648 78.4764C109.258 78.4764 108.941 78.7929 108.941 79.1834C108.941 79.5739 109.258 79.8905 109.648 79.8905Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.031 79.8905C128.422 79.8905 128.738 79.5739 128.738 79.1834C128.738 78.7929 128.422 78.4764 128.031 78.4764C127.641 78.4764 127.324 78.7929 127.324 79.1834C127.324 79.5739 127.641 79.8905 128.031 79.8905Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6709 115.243C52.0614 115.243 52.3779 114.926 52.3779 114.536C52.3779 114.145 52.0614 113.828 51.6709 113.828C51.2804 113.828 50.9639 114.145 50.9639 114.536C50.9639 114.926 51.2804 115.243 51.6709 115.243Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.547 58.6796C119.937 58.6796 120.254 58.363 120.254 57.9725C120.254 57.5821 119.937 57.2655 119.547 57.2655C119.156 57.2655 118.84 57.5821 118.84 57.9725C118.84 58.363 119.156 58.6796 119.547 58.6796Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2647 108.172C91.6551 108.172 91.9717 107.856 91.9717 107.465C91.9717 107.075 91.6551 106.758 91.2647 106.758C90.8742 106.758 90.5576 107.075 90.5576 107.465C90.5576 107.856 90.8742 108.172 91.2647 108.172Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.71 41.7106C76.1005 41.7106 76.417 41.394 76.417 41.0035C76.417 40.6131 76.1005 40.2965 75.71 40.2965C75.3195 40.2965 75.0029 40.6131 75.0029 41.0035C75.0029 41.394 75.3195 41.7106 75.71 41.7106Z",
    fill: "#10049B",
    fillOpacity: 0.24
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_664_36794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.605 38.1754C155.605 37.7849 155.289 37.4683 154.898 37.4683C154.508 37.4683 154.191 37.7849 154.191 38.1754V39.5894C154.191 39.9799 154.508 40.2965 154.898 40.2965C155.289 40.2965 155.605 39.9799 155.605 39.5894V38.1754Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.605 49.488C155.605 49.0975 155.289 48.7809 154.898 48.7809C154.508 48.7809 154.191 49.0975 154.191 49.488V50.9021C154.191 51.2925 154.508 51.6091 154.898 51.6091C155.289 51.6091 155.605 51.2925 155.605 50.9021V49.488Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.605 60.8006C155.605 60.4101 155.289 60.0936 154.898 60.0936C154.508 60.0936 154.191 60.4101 154.191 60.8006V62.2147C154.191 62.6052 154.508 62.9217 154.898 62.9217C155.289 62.9217 155.605 62.6052 155.605 62.2147V60.8006Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.605 72.113C155.605 71.7226 155.289 71.406 154.898 71.406C154.508 71.406 154.191 71.7226 154.191 72.113V73.5271C154.191 73.9176 154.508 74.2342 154.898 74.2342C155.289 74.2342 155.605 73.9176 155.605 73.5271V72.113Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.605 83.4257C155.605 83.0352 155.289 82.7186 154.898 82.7186C154.508 82.7186 154.191 83.0352 154.191 83.4257V84.8397C154.191 85.2302 154.508 85.5468 154.898 85.5468C155.289 85.5468 155.605 85.2302 155.605 84.8397V83.4257Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.605 94.7383C155.605 94.3479 155.289 94.0313 154.898 94.0313C154.508 94.0313 154.191 94.3479 154.191 94.7383V96.1524C154.191 96.5429 154.508 96.8595 154.898 96.8595C155.289 96.8595 155.605 96.5429 155.605 96.1524V94.7383Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.605 106.051C155.605 105.66 155.289 105.344 154.898 105.344C154.508 105.344 154.191 105.66 154.191 106.051V107.465C154.191 107.856 154.508 108.172 154.898 108.172C155.289 108.172 155.605 107.856 155.605 107.465V106.051Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.605 117.363C155.605 116.973 155.289 116.656 154.898 116.656C154.508 116.656 154.191 116.973 154.191 117.363V118.777C154.191 119.168 154.508 119.485 154.898 119.485C155.289 119.485 155.605 119.168 155.605 118.777V117.363Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.605 128.676C155.605 128.286 155.289 127.969 154.898 127.969C154.508 127.969 154.191 128.286 154.191 128.676V130.09C154.191 130.481 154.508 130.797 154.898 130.797C155.289 130.797 155.605 130.481 155.605 130.09V128.676Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.887 48.7809H165.504C164.723 48.7809 164.09 49.414 164.09 50.195C164.09 50.976 164.723 51.6091 165.504 51.6091H183.887C184.668 51.6091 185.301 50.976 185.301 50.195C185.301 49.414 184.668 48.7809 183.887 48.7809Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.199 48.7809H190.957C190.176 48.7809 189.543 49.414 189.543 50.195C189.543 50.976 190.176 51.6091 190.957 51.6091H195.199C195.98 51.6091 196.613 50.976 196.613 50.195C196.613 49.414 195.98 48.7809 195.199 48.7809Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.754 48.7809H202.27C201.489 48.7809 200.855 49.414 200.855 50.195C200.855 50.976 201.489 51.6091 202.27 51.6091H210.754C211.535 51.6091 212.168 50.976 212.168 50.195C212.168 49.414 211.535 48.7809 210.754 48.7809Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.957 71.406H176.816C176.035 71.406 175.402 72.0391 175.402 72.8201C175.402 73.601 176.035 74.2342 176.816 74.2342H190.957C191.738 74.2342 192.371 73.601 192.371 72.8201C192.371 72.0391 191.738 71.406 190.957 71.406Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.168 71.406H198.027C197.246 71.406 196.613 72.0391 196.613 72.8201C196.613 73.601 197.246 74.2342 198.027 74.2342H212.168C212.949 74.2342 213.582 73.601 213.582 72.8201C213.582 72.0391 212.949 71.406 212.168 71.406Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.207 71.406H219.238C218.457 71.406 217.824 72.0391 217.824 72.8201C217.824 73.601 218.457 74.2342 219.238 74.2342H236.207C236.988 74.2342 237.621 73.601 237.621 72.8201C237.621 72.0391 236.988 71.406 236.207 71.406Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.692 71.406H243.278C242.497 71.406 241.864 72.0391 241.864 72.8201C241.864 73.601 242.497 74.2342 243.278 74.2342H244.692C245.473 74.2342 246.106 73.601 246.106 72.8201C246.106 72.0391 245.473 71.406 244.692 71.406Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.574 37.4683H165.504C164.723 37.4683 164.09 38.1014 164.09 38.8823C164.09 39.6633 164.723 40.2964 165.504 40.2964H172.574C173.355 40.2964 173.988 39.6633 173.988 38.8823C173.988 38.1014 173.355 37.4683 172.574 37.4683Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.887 37.4683H179.645C178.864 37.4683 178.23 38.1014 178.23 38.8823C178.23 39.6633 178.864 40.2964 179.645 40.2964H183.887C184.668 40.2964 185.301 39.6633 185.301 38.8823C185.301 38.1014 184.668 37.4683 183.887 37.4683Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.653 37.4683H190.957C190.176 37.4683 189.543 38.1014 189.543 38.8823C189.543 39.6633 190.176 40.2964 190.957 40.2964H220.653C221.434 40.2964 222.067 39.6633 222.067 38.8823C222.067 38.1014 221.434 37.4683 220.653 37.4683Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.512 60.0936H176.816C176.035 60.0936 175.402 60.7267 175.402 61.5076C175.402 62.2886 176.035 62.9217 176.816 62.9217H206.512C207.293 62.9217 207.926 62.2886 207.926 61.5076C207.926 60.7267 207.293 60.0936 206.512 60.0936Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.723 60.0936H213.582C212.801 60.0936 212.168 60.7267 212.168 61.5076C212.168 62.2886 212.801 62.9217 213.582 62.9217H227.723C228.504 62.9217 229.137 62.2886 229.137 61.5076C229.137 60.7267 228.504 60.0936 227.723 60.0936Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.278 60.0936H234.794C234.013 60.0936 233.38 60.7267 233.38 61.5076C233.38 62.2886 234.013 62.9217 234.794 62.9217H243.278C244.059 62.9217 244.692 62.2886 244.692 61.5076C244.692 60.7267 244.059 60.0936 243.278 60.0936Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.957 82.7186H185.301C184.52 82.7186 183.887 83.3517 183.887 84.1327C183.887 84.9137 184.52 85.5468 185.301 85.5468H190.957C191.738 85.5468 192.371 84.9137 192.371 84.1327C192.371 83.3517 191.738 82.7186 190.957 82.7186Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.168 82.7186H198.027C197.246 82.7186 196.613 83.3517 196.613 84.1327C196.613 84.9137 197.246 85.5468 198.027 85.5468H212.168C212.949 85.5468 213.582 84.9137 213.582 84.1327C213.582 83.3517 212.949 82.7186 212.168 82.7186Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.066 82.7186H219.238C218.457 82.7186 217.824 83.3517 217.824 84.1327C217.824 84.9137 218.457 85.5468 219.238 85.5468H222.066C222.847 85.5468 223.481 84.9137 223.481 84.1327C223.481 83.3517 222.847 82.7186 222.066 82.7186Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.036 82.7186H229.138C228.357 82.7186 227.724 83.3517 227.724 84.1327C227.724 84.9137 228.357 85.5468 229.138 85.5468H239.036C239.817 85.5468 240.45 84.9137 240.45 84.1327C240.45 83.3517 239.817 82.7186 239.036 82.7186Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.988 94.0313H165.504C164.723 94.0313 164.09 94.6644 164.09 95.4454C164.09 96.2264 164.723 96.8595 165.504 96.8595H173.988C174.769 96.8595 175.402 96.2264 175.402 95.4454C175.402 94.6644 174.769 94.0313 173.988 94.0313Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.301 94.0313H181.059C180.278 94.0313 179.645 94.6644 179.645 95.4454C179.645 96.2264 180.278 96.8595 181.059 96.8595H185.301C186.082 96.8595 186.715 96.2264 186.715 95.4454C186.715 94.6644 186.082 94.0313 185.301 94.0313Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.895 94.0313H192.371C191.59 94.0313 190.957 94.6644 190.957 95.4454C190.957 96.2264 191.59 96.8595 192.371 96.8595H224.895C225.676 96.8595 226.309 96.2264 226.309 95.4454C226.309 94.6644 225.676 94.0313 224.895 94.0313Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.38 94.0313H231.966C231.185 94.0313 230.552 94.6644 230.552 95.4454C230.552 96.2264 231.185 96.8595 231.966 96.8595H233.38C234.161 96.8595 234.794 96.2264 234.794 95.4454C234.794 94.6644 234.161 94.0313 233.38 94.0313Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.988 116.656H165.504C164.723 116.656 164.09 117.289 164.09 118.07C164.09 118.851 164.723 119.485 165.504 119.485H173.988C174.769 119.485 175.402 118.851 175.402 118.07C175.402 117.289 174.769 116.656 173.988 116.656Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.027 116.656H181.059C180.278 116.656 179.645 117.289 179.645 118.07C179.645 118.851 180.278 119.485 181.059 119.485H198.027C198.808 119.485 199.442 118.851 199.442 118.07C199.442 117.289 198.808 116.656 198.027 116.656Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.34 116.656H205.098C204.317 116.656 203.684 117.289 203.684 118.07C203.684 118.851 204.317 119.485 205.098 119.485H209.34C210.121 119.485 210.754 118.851 210.754 118.07C210.754 117.289 210.121 116.656 209.34 116.656Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.138 116.656H216.411C215.63 116.656 214.997 117.289 214.997 118.07C214.997 118.851 215.63 119.485 216.411 119.485H229.138C229.919 119.485 230.552 118.851 230.552 118.07C230.552 117.289 229.919 116.656 229.138 116.656Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.957 105.344H176.816C176.035 105.344 175.402 105.977 175.402 106.758C175.402 107.539 176.035 108.172 176.816 108.172H190.957C191.738 108.172 192.371 107.539 192.371 106.758C192.371 105.977 191.738 105.344 190.957 105.344Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.512 105.344H198.027C197.246 105.344 196.613 105.977 196.613 106.758C196.613 107.539 197.246 108.172 198.027 108.172H206.512C207.293 108.172 207.926 107.539 207.926 106.758C207.926 105.977 207.293 105.344 206.512 105.344Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.551 105.344H213.582C212.801 105.344 212.168 105.977 212.168 106.758C212.168 107.539 212.801 108.172 213.582 108.172H230.551C231.332 108.172 231.965 107.539 231.965 106.758C231.965 105.977 231.332 105.344 230.551 105.344Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.036 105.344H237.622C236.841 105.344 236.208 105.977 236.208 106.758C236.208 107.539 236.841 108.172 237.622 108.172H239.036C239.817 108.172 240.45 107.539 240.45 106.758C240.45 105.977 239.817 105.344 239.036 105.344Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_664_36794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.031,
    y: 94.0314,
    width: 33.9378,
    height: 33.9378,
    rx: 16.9689,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_664_36794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.097 107.494C148.097 107.152 147.82 106.875 147.478 106.875C147.136 106.875 146.859 107.152 146.859 107.494C146.859 109.495 146.417 110.795 145.608 111.604C144.798 112.414 143.499 112.856 141.498 112.856C141.156 112.856 140.879 113.133 140.879 113.474C140.879 113.816 141.156 114.093 141.498 114.093C143.499 114.093 144.798 114.535 145.608 115.345C146.417 116.154 146.859 117.454 146.859 119.455C146.859 119.796 147.136 120.073 147.478 120.073C147.82 120.073 148.097 119.796 148.097 119.455C148.097 117.454 148.539 116.154 149.348 115.345C150.158 114.535 151.457 114.093 153.458 114.093C153.8 114.093 154.077 113.816 154.077 113.474C154.077 113.133 153.8 112.856 153.458 112.856C151.457 112.856 150.158 112.414 149.348 111.604C148.539 110.795 148.097 109.495 148.097 107.494Z",
    fill: "url(#paint4_linear_664_36794)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.086 102.545C141.086 102.203 140.809 101.926 140.467 101.926C140.126 101.926 139.849 102.203 139.849 102.545C139.849 103.83 139.564 104.614 139.091 105.087C138.618 105.56 137.834 105.844 136.549 105.844C136.208 105.844 135.931 106.121 135.931 106.463C135.931 106.804 136.208 107.081 136.549 107.081C137.834 107.081 138.618 107.366 139.091 107.839C139.564 108.312 139.849 109.096 139.849 110.381C139.849 110.723 140.126 111 140.467 111C140.809 111 141.086 110.723 141.086 110.381C141.086 109.096 141.371 108.312 141.844 107.839C142.317 107.366 143.101 107.081 144.386 107.081C144.727 107.081 145.004 106.804 145.004 106.463C145.004 106.121 144.727 105.844 144.386 105.844C143.101 105.844 142.317 105.56 141.844 105.087C141.371 104.614 141.086 103.83 141.086 102.545Z",
    fill: "url(#paint5_linear_664_36794)"
  }))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_664_36794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.1719,
    y: 34.6493,
    width: 25.1777,
    height: 25.1777,
    rx: 12.5888,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_664_36794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0578 44.6372C64.0578 44.3837 63.8523 44.1782 63.5988 44.1782C63.3453 44.1782 63.1398 44.3837 63.1398 44.6372C63.1398 46.1217 62.8119 47.0858 62.2113 47.6864C61.6107 48.287 60.6466 48.6149 59.1621 48.6149C58.9086 48.6149 58.7031 48.8204 58.7031 49.0739C58.7031 49.3274 58.9086 49.5328 59.1621 49.5328C60.6466 49.5328 61.6107 49.8608 62.2113 50.4614C62.8119 51.062 63.1398 52.026 63.1398 53.5106C63.1398 53.764 63.3453 53.9695 63.5988 53.9695C63.8523 53.9695 64.0578 53.764 64.0578 53.5106C64.0578 52.026 64.3857 51.062 64.9863 50.4614C65.5869 49.8608 66.551 49.5328 68.0354 49.5328C68.289 49.5328 68.4944 49.3274 68.4944 49.0739C68.4944 48.8204 68.289 48.6149 68.0354 48.6149C66.551 48.6149 65.5869 48.287 64.9863 47.6864C64.3857 47.0858 64.0578 46.1217 64.0578 44.6372Z",
    fill: "url(#paint6_linear_664_36794)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.856 40.9649C58.856 40.7115 58.6505 40.506 58.397 40.506C58.1435 40.506 57.9381 40.7115 57.9381 40.9649C57.9381 41.9182 57.727 42.4999 57.3761 42.8508C57.0251 43.2017 56.4435 43.4128 55.4902 43.4128C55.2367 43.4128 55.0312 43.6183 55.0312 43.8717C55.0312 44.1252 55.2367 44.3307 55.4902 44.3307C56.4435 44.3307 57.0251 44.5418 57.3761 44.8927C57.727 45.2436 57.9381 45.8253 57.9381 46.7785C57.9381 47.032 58.1435 47.2375 58.397 47.2375C58.6505 47.2375 58.856 47.032 58.856 46.7785C58.856 45.8253 59.0671 45.2436 59.418 44.8927C59.7689 44.5418 60.3505 44.3307 61.3038 44.3307C61.5573 44.3307 61.7628 44.1252 61.7628 43.8717C61.7628 43.6183 61.5573 43.4128 61.3038 43.4128C60.3505 43.4128 59.7689 43.2017 59.418 42.8508C59.0671 42.4999 58.856 41.9182 58.856 40.9649Z",
    fill: "url(#paint7_linear_664_36794)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M102.476 41.0632H82.3016C81.1874 41.0632 80.2842 41.9664 80.2842 43.0806C80.2842 44.1948 81.1874 45.0981 82.3016 45.0981H102.476C103.59 45.0981 104.493 44.1948 104.493 43.0806C104.493 41.9664 103.59 41.0632 102.476 41.0632Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.668 49.378H82.3016C81.1874 49.378 80.2842 50.2812 80.2842 51.3954C80.2842 52.5096 81.1874 53.4129 82.3016 53.4129H124.668C125.782 53.4129 126.685 52.5096 126.685 51.3954C126.685 50.2812 125.782 49.378 124.668 49.378Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_664_36794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.1719,
    y: 68.827,
    width: 25.1777,
    height: 25.1777,
    rx: 12.5888,
    fill: "#F7FDFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.476 75.2407H82.3016C81.1874 75.2407 80.2842 76.144 80.2842 77.2582C80.2842 78.3724 81.1874 79.2756 82.3016 79.2756H102.476C103.59 79.2756 104.493 78.3724 104.493 77.2582C104.493 76.144 103.59 75.2407 102.476 75.2407Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.668 83.5559H82.3016C81.1874 83.5559 80.2842 84.4591 80.2842 85.5733C80.2842 86.6875 81.1874 87.5908 82.3016 87.5908H124.668C125.782 87.5908 126.685 86.6875 126.685 85.5733C126.685 84.4591 125.782 83.5559 124.668 83.5559Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_664_36794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.1719,
    y: 103.005,
    width: 25.1777,
    height: 25.1777,
    rx: 12.5888,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_664_36794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_664_36794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0578 112.992C64.0578 112.739 63.8523 112.534 63.5988 112.534C63.3453 112.534 63.1398 112.739 63.1398 112.992C63.1398 114.477 62.8119 115.441 62.2113 116.042C61.6107 116.642 60.6466 116.97 59.1621 116.97C58.9086 116.97 58.7031 117.176 58.7031 117.429C58.7031 117.683 58.9086 117.888 59.1621 117.888C60.6466 117.888 61.6107 118.216 62.2113 118.817C62.8119 119.417 63.1398 120.381 63.1398 121.866C63.1398 122.119 63.3453 122.325 63.5988 122.325C63.8523 122.325 64.0578 122.119 64.0578 121.866C64.0578 120.381 64.3857 119.417 64.9863 118.817C65.5869 118.216 66.551 117.888 68.0354 117.888C68.289 117.888 68.4944 117.683 68.4944 117.429C68.4944 117.176 68.289 116.97 68.0354 116.97C66.551 116.97 65.5869 116.642 64.9863 116.042C64.3857 115.441 64.0578 114.477 64.0578 112.992Z",
    fill: "url(#paint8_linear_664_36794)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.856 109.32C58.856 109.067 58.6505 108.861 58.397 108.861C58.1435 108.861 57.9381 109.067 57.9381 109.32C57.9381 110.274 57.727 110.855 57.3761 111.206C57.0251 111.557 56.4435 111.768 55.4902 111.768C55.2367 111.768 55.0312 111.974 55.0312 112.227C55.0312 112.481 55.2367 112.686 55.4902 112.686C56.4435 112.686 57.0251 112.897 57.3761 113.248C57.727 113.599 57.9381 114.181 57.9381 115.134C57.9381 115.387 58.1435 115.593 58.397 115.593C58.6505 115.593 58.856 115.387 58.856 115.134C58.856 114.181 59.0671 113.599 59.418 113.248C59.7689 112.897 60.3505 112.686 61.3038 112.686C61.5573 112.686 61.7628 112.481 61.7628 112.227C61.7628 111.974 61.5573 111.768 61.3038 111.768C60.3505 111.768 59.7689 111.557 59.418 111.206C59.0671 110.855 58.856 110.274 58.856 109.32Z",
    fill: "url(#paint9_linear_664_36794)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M102.476 109.418H82.3016C81.1874 109.418 80.2842 110.322 80.2842 111.436C80.2842 112.55 81.1874 113.453 82.3016 113.453H102.476C103.59 113.453 104.493 112.55 104.493 111.436C104.493 110.322 103.59 109.418 102.476 109.418Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.668 117.733H82.3016C81.1874 117.733 80.2842 118.637 80.2842 119.751C80.2842 120.865 81.1874 121.768 82.3016 121.768H124.668C125.782 121.768 126.685 120.865 126.685 119.751C126.685 118.637 125.782 117.733 124.668 117.733Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_664_36794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.1719,
    y: 137.182,
    width: 25.1777,
    height: 25.1777,
    rx: 12.5888,
    fill: "#F7FDFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.476 143.596H82.3016C81.1874 143.596 80.2842 144.499 80.2842 145.613C80.2842 146.728 81.1874 147.631 82.3016 147.631H102.476C103.59 147.631 104.493 146.728 104.493 145.613C104.493 144.499 103.59 143.596 102.476 143.596Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.668 151.911H82.3016C81.1874 151.911 80.2842 152.814 80.2842 153.929C80.2842 155.043 81.1874 155.946 82.3016 155.946H124.668C125.782 155.946 126.685 155.043 126.685 153.929C126.685 152.814 125.782 151.911 124.668 151.911Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdddii_664_36794",
    x: 0.764397,
    y: 0.702347,
    width: 288.471,
    height: 243.221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.07036
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_36794"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3126
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.9689
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_36794",
    result: "effect2_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.41407
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.41407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_36794",
    result: "effect3_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41407,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_36794",
    result: "effect4_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_36794",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.24222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.12111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8.48444
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.353518
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_36794",
    result: "effect6_innerShadow_664_36794"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_664_36794",
    x: 125.203,
    y: 92.6173,
    width: 39.5938,
    height: 39.594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.41407,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.41407
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.41407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_36794",
    result: "effect2_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_36794",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_664_36794",
    x: 47.0737,
    y: 33.6002,
    width: 29.374,
    height: 29.3739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.04907,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.04907
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_36794",
    result: "effect2_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_36794",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_664_36794",
    x: 47.0737,
    y: 67.7779,
    width: 29.374,
    height: 29.3739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.04907,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.04907
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_36794",
    result: "effect2_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_36794",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_664_36794",
    x: 47.0737,
    y: 101.956,
    width: 29.374,
    height: 29.3739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.04907,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.04907
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_36794",
    result: "effect2_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_36794",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_664_36794",
    x: 47.0737,
    y: 136.133,
    width: 29.374,
    height: 29.3739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.04907,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.04907
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.04907
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_36794",
    result: "effect2_dropShadow_664_36794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_36794",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_36794",
    x1: 145,
    y1: 23.3275,
    x2: 145,
    y2: 198.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_664_36794",
    x1: 34.7021,
    y1: 111,
    x2: 255.298,
    y2: 111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    stopColor: "#F3F2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_664_36794",
    x1: 145,
    y1: 33.2262,
    x2: 145,
    y2: 105.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B76E1",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B71E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_664_36794",
    x1: 145,
    y1: 142.11,
    x2: 145,
    y2: 187.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B71E1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B78E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_664_36794",
    x1: 145.003,
    y1: 101.926,
    x2: 149.245,
    y2: 123.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_664_36794",
    x1: 145.004,
    y1: 101.926,
    x2: 149.246,
    y2: 123.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_664_36794",
    x1: 61.7629,
    y1: 40.5065,
    x2: 64.9099,
    y2: 56.6796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_664_36794",
    x1: 61.7628,
    y1: 40.506,
    x2: 64.9098,
    y2: 56.6791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EDFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_664_36794",
    x1: 61.7629,
    y1: 108.862,
    x2: 64.9099,
    y2: 125.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_664_36794",
    x1: 61.7628,
    y1: 108.861,
    x2: 64.9098,
    y2: 125.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EDFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.7021,
    y: 23.3275,
    width: 220.595,
    height: 175.345,
    rx: 11.3126,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.2585,
    height: 141.407,
    fill: "white",
    transform: "translate(46.7217 40.2965)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.2585,
    height: 141.407,
    fill: "white",
    transform: "translate(46.7217 40.2965)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.2585,
    height: 141.407,
    fill: "white",
    transform: "translate(46.7217 40.2965)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.9147,
    height: 93.3288,
    fill: "white",
    transform: "translate(154.191 37.4683)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.9147,
    height: 93.3288,
    fill: "white",
    transform: "translate(154.191 37.4683)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.9147,
    height: 93.3288,
    fill: "white",
    transform: "translate(154.191 37.4683)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2111,
    height: 19.797,
    fill: "white",
    transform: "translate(134.395 101.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2111,
    height: 19.797,
    fill: "white",
    transform: "translate(134.395 101.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2111,
    height: 19.797,
    fill: "white",
    transform: "translate(134.395 101.102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.736,
    height: 14.687,
    fill: "white",
    transform: "translate(53.8926 39.8949)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.736,
    height: 14.687,
    fill: "white",
    transform: "translate(53.8926 39.8949)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.736,
    height: 14.687,
    fill: "white",
    transform: "translate(53.8926 108.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.736,
    height: 14.687,
    fill: "white",
    transform: "translate(53.8926 108.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_664_36794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.736,
    height: 14.687,
    fill: "white",
    transform: "translate(53.8926 108.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGptChat);
export default __webpack_public_path__ + "static/media/gpt-chat.2b6899fb23c8c640bd3176a8d17c9434.svg";
export { ForwardRef as ReactComponent };